import React from 'react';
import Toast, { ToastType, ToastVariant } from './Toast';
import './Toast.scss';

export interface ToastData {
  id: string;
  type: ToastType;
  message: string;
  title?: string;
  duration?: number;
  href?: string;
  variant?: ToastVariant;
}

interface ToastContainerProps {
  toasts: ToastData[];
  onRemoveToast: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemoveToast }) => {
  if (toasts.length === 0) return null;

  const system = toasts.filter(t => t.variant !== 'notification');
  const notifs = toasts.filter(t => t.variant === 'notification');

  const render = (items: ToastData[]) =>
    items.map(toast => (
      <Toast
        key={toast.id}
        id={toast.id}
        type={toast.type}
        message={toast.message}
        title={toast.title}
        duration={toast.duration}
        href={toast.href}
        variant={toast.variant}
        onClose={onRemoveToast}
      />
    ));

  return (
    <>
      {system.length > 0 ? (
        <div className="toast-container toast-container--system">{render(system)}</div>
      ) : null}
      {notifs.length > 0 ? (
        <div className="toast-container toast-container--notif">{render(notifs)}</div>
      ) : null}
    </>
  );
};

export default ToastContainer;
